<template>
  <v-container class="pa-0" fluid>
    <!-- A search input to filter the data of the table -->
    <v-layout justify-center>
      <v-flex xs12 sm8 md6 lg4>
        <v-text-field
          v-model="search"
          clearable
          label="Buscar en las clasificaciones"
          :loading="loadingClassifications"
          prepend-icon="search"
        />
      </v-flex>
    </v-layout>
    <!-- The table itself -->
    <v-layout :class="elevation">
      <v-flex>
        <v-data-table					
          :headers="headers"
          :items="classifications"
          :loading="loadingClassifications"
          :no-data-text="noDataText"
          no-results-text="Ninguna clasificación calza con lo buscado"
          :pagination.sync="pagination"
          :search="search"
        >
          <template #items="{ item }">
            <tr @click="goToPredictions(item)" style="cursor: pointer">
              <td>{{ item.id }}</td>
              <td v-if="item.googleId">{{ item.googleId }}</td>
              <td>{{ item.displayableText }}</td>
              <td class="text-xs-right">{{ item.numItems.classified }}</td>
              <td class="text-xs-right">{{ item.numItems.unclassifiedWithPredictions }}</td>
              <td v-if="allowMerge" class="text-xs-center">
                <v-table-merge-checkbox :classification="item" />
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
    <!-- An aside floating action button to show to merge the selected classifications -->
    <v-table-merge-button />
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("classifier");

import VTableMergeButton from "./TableMergeButton";
import VTableMergeCheckbox from "./TableMergeCheckbox";

export default {
  components: {
    VTableMergeButton,
    VTableMergeCheckbox
  },
  props: {
    elevation: {
      type: String,
      default: "elevation-10"
    }
  },
  data: () => ({
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "numItems.unclassifiedWithPredictions"
    },
    search: null
  }),
  computed: {
    ...mapState([
      // "classifications",
      "classificationsSellerId",
      "loadingClassifications",
    ]),
    /**
     * A computed property that indicates if the component must show the "merge"
     * column to merge some classifications or not.
     * Currently it only support merging the "brands classifications" that are
     * owned by the seller id 132.
     */
    allowMerge() {
      return this.classificationsSellerId === 132;
    },
    headers() {
      const baseHeaders = [
        {
          text: "Id",
          value: "id",
          align: "left",
          sortable: true
        },
        {
          text: "Google Id",
          value: "googleId",
          align: "left",
          sortable: true
        },
        {
          text: "Breadcrumb",
          value: "breadcrumb",
          align: "left",
          sortable: true
        },
        {
          text: "QMIs",
          value: "numItems.classified",
          align: "right",
          sortable: true
        },
        {
          text: "QMIs con predicciones",
          value: "numItems.unclassifiedWithPredictions",
          align: "right",
          sortable: true
        }
      ];

      if (this.allowMerge) {
        baseHeaders.push({
          text: "Unir",
          align: "center",
          sortable: false
        });
      }

      switch (this.classificationsSellerId) {
        case 111:
          /* Show the google id of the Google classifications */
          return baseHeaders;
        default:
          /* Do not show the google id other wise */
          return [baseHeaders[0], ...baseHeaders.slice(2)];
      }
    },
    noDataText() {
      return this.loadingClassifications
        ? "Cargando clasificaciones"
        : "Al parecer hubo un problema cargando las clasificaciones";
    },
		classifications() {
      return this.$store.state.classifier.classifications
			.filter((qmi) => {
				return qmi.enabled === true || qmi.enabled === null;
			})
			.map(
        classification => ({
          ...classification,
          displayableText: classification.breadcrumb ? classification.breadcrumb : classification.name,
          breadcrumb: classification.breadcrumb ? classification.breadcrumb : classification.name
        })
      );
    },
  },
  created() {
    if (!this.loadingClassifications && !this.classifications.length) {
      this.getClassifications();
    }
  },
  methods: {
    ...mapActions(["getClassifications"]),
    goToPredictions(classification) {
      this.$router.push({
        name: "classifier/predictions",
        params: { classificationId: classification.id }
      });
    }
  }
};
</script>